<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-full">
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="saveData">저장하기</button>
        </div>
      </div>
      <!-- 회원 기본 정보 -->
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="1:1문의 기본 정보">
            <div style="overflow-x: auto">
              <div style="min-width:1080px">
                <div class="flex" style="border-bottom: 2px solid #dbdbdb; text-align: center">
                  <div class="lp-param-td lp-param-head" style="width: 20%">필드명 및 포맷 비주얼</div>
                  <div class="lp-param-td lp-param-head" style="width: 10%">활성화 여부</div>
                  <div class="lp-param-td lp-param-head" style="width: 10%">필수입력 여부</div>
                  <div class="lp-param-td lp-param-head" style="width: 20%">label</div>
                  <div class="lp-param-td lp-param-head" style="width: 20%">description</div>
                  <div class="lp-param-td lp-param-head" style="width: 20%">placeholder</div>
                </div>

                <div v-for="(info, idx) in value.data" :key="'info-'+idx" class="flex">
                  <div class="lp-param-td" style="width: 20%">{{ info.name }}</div>
                  <div class="lp-param-td" style="width: 10%">
                    <toggle-button @change="e=> info.enable = e.value"
                                   :value="info.enable"
                                   :sync="true"
                                   class="changed-font"
                                   :width="70"
                                   :height="24"
                                   :labels="{'checked':'활성화', 'unchecked':'비활성화'}"></toggle-button>
                  </div>
                  <div class="lp-param-td" style="width: 10%">
                    <toggle-button @change="e=> selectValidate(e, idx)"
                                   :value="info.validate.valid_required"
                                   :sync="true"
                                   class="changed-font"
                                   :width="70"
                                   :height="24"
                                   :labels="{'checked':'사용', 'unchecked':'미사용'}"></toggle-button>
                  </div>
                  <div class="lp-param-td" style="width: 20%"><input class="input"
                             :value="info.label"
                             @input="e=> info.label = e.target.value"
                             type="text" maxlength="20"></div>
                  <div class="lp-param-td" style="width: 20%"><input class="input"
                             :value="info.description"
                             @input="e=> info.description = e.target.value"
                             type="text" maxlength="30"></div>
                  <div class="lp-param-td" style="width: 20%"><input class="input"
                             :value="info.placeholder"
                             @input="e=> info.placeholder = e.target.value"
                             type="text" maxlength="30"></div>
                </div>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import LpSortDropDown from '../../module/common/LpSortDropDown'
  import LpInputText from '../../module/common/LpInputText'
  import LpRadio from '../../module/common/LpRadio'
  import LpCheckBool from '../../module/common/LpCheckBool'
  import {SweetModal} from 'sweet-modal-vue'
  import LpModal from '../../module/common/LpModal.vue'
  import AdminBoxItem from "../../module/admin/AdminBoxItem";
  import draggable from 'vuedraggable'

  export default {
    layout: 'Main',
    components: {
      AdminBoxItem,
      SweetModal, LpSortDropDown,
      LpInputText, LpRadio, LpModal,
      LpCheckBool, draggable
    },
    watch: {
      modalStatus(n) {
        if(n==='close'){
          this.getData();
        }
      }
    },
    data() {
      return {
        value: {
          data: []
        }
      }
    },
    created() {
      this.getData();
    },
    methods: {
      selectValidate(e, idx) {
        this.value.data[idx].validate.valid_required = e.value;
        this.value.data[idx].validate.required = e.value;
      },
      getData() {
        this.$axios.get(this.getUrl('inquiry/personal/formdata')).then(res => {
          this.value.data = res.data;
        })
      },
      /*getDetail(){
        this.$axios.get(this.getUrl('product/inquiry/formdata')).then(res=>{
          if(res.status===200) {
            this.value.data = res.data.data;
          }
        })
      },*/
      saveData() {
        this.$axios.patch(this.getUrl('inquiry/personal/formdata'), this.value).then(res => {
          if (res.status === 200) {
            this.toast('저장되었습니다.');
          }
        })
      },
      paramType(param) {
        let value = '';
        switch (param) {
          case 0:
            value = '입력형';
            break;
          case 1:
            value = '숫자(정수형)';
            break;
          case 2:
            value = '숫자(실수형)';
            break;
          case 3:
            value = '선택형';
            break;
          case 4:
            value = '지역형';
            break;
          case 5:
            value = '주소형';
            break;
          case 6:
            value = '직선형 스탭';
            break;
          case 7:
            value = '날짜형';
            break;
        }
        return value;
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .tr-whole-borde th
    padding 12px 6px
    text-align center

  .many-field-tr td
    padding 6px

  .td-btn
    cursor pointer

  .td-btn:hover
    background-color #caf6ec
    font-weight bold
    font-size 1rem
    color $primary

  .prod-list-page-selected
    color #18a4ed

  .prod-list-page-not-selected
    color #666

  .primary
    color $primary

  .prod-tag
    background-color #ebab39
    display inline-block
    padding 4px 10px
    color #fff
    border-radius 3px
    margin 2px

  .prod-search-bgcolor
    background-color #f1f7f8

  .lp-form-type
    border 1px solid #7a7a7a
    border-radius 3px
    cursor pointer
    margin-right 8px
    margin-bottom 2px

  .selected
    color $primary
    border 1px solid $primary
    background-color unset

  .lp-form-add
    width 60px
    border 1px solid
    border-radius 3px
    padding 6px 8px
    text-align center
    margin auto 0
    margin-right 8px
    cursor pointer

  .lp-form-type-input
    border 0
    box-shadow unset

  .lp-param-td
    padding 0.5em 0.75em
    text-align center

  .lp-param-head
    color #363636
    font-weight bold

</style>
